'use client';
import { twMerge } from 'tailwind-merge';
import { Search } from 'lucide-react';
import { Button } from '@ui/components/ui/button';

export interface ISearchInput {
  placeholder?: string;
  onSearchClick?: () => void;
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  className?: string;
  showSearch?: boolean;
}

export function SearchInput({
  placeholder = 'Search...',
  onSearchClick,
  searchValue = '',
  onSearchChange,
  className = '',
  showSearch = true,
}: ISearchInput) {
  if (!showSearch) {
    return null;
  }

  return (
    <div className={twMerge('w-full sm:w-auto', className)}>
      {/* Desktop Search */}
      <div className="hidden sm:block relative w-full max-w-xs lg:max-w-sm">
        <Search
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer"
          size={18}
          onClick={onSearchClick}
        />
        <input
          type="text"
          onClick={onSearchClick}
          placeholder={placeholder}
          className="w-full pl-10 pr-4 py-2 border border-slate-200 rounded-md focus:outline-none focus:border-black cursor-pointer"
          readOnly={!onSearchChange}
        />
      </div>

      {/* Mobile Search Icon */}
      <div className="sm:hidden">
        <Button
          variant="outline"
          size="sm"
          onClick={onSearchClick}
          className="p-2 h-8 w-8 bg-white border border-slate-200 hover:bg-gray-50">
          <Search className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
